//auth
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const FETCHUSER = 'FETCHUSER'
export const UPDATEUSER = 'UPDATEUSER'


//posts
export const FETCH = "FETCH"
export const CREATE = "CREATE" 
export const UPDATE = "UPDATE"
export const DELETE = "DELETE"